// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createEmployee,
  deleteEmployee,
  getEmployeeDetail,
  getEmployeeList,
  getEmployeeReview,
  updateEmployee,
  updateStatusEmployee,
  uploadFileExcel,
} from './employeeThunk';

export interface IEmployeeState {
  isRefreshEmployeeList: boolean;
}

export const initialState: IEmployeeState = {
  isRefreshEmployeeList: false,
};

const employeeSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    setRefreshEmployeeList(state, action) {
      state.isRefreshEmployeeList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get employee list
    builder
      .addCase(getEmployeeList.pending, (_state) => {})
      .addCase(getEmployeeList.fulfilled, (_state) => {})
      .addCase(getEmployeeList.rejected, (_state) => {});

    // POST: Create employee
    builder
      .addCase(createEmployee.pending, (_state) => {})
      .addCase(createEmployee.fulfilled, (_state) => {})
      .addCase(createEmployee.rejected, (_state) => {});

    // GET: Get employee detail
    builder
      .addCase(getEmployeeDetail.pending, (_state) => {})
      .addCase(getEmployeeDetail.fulfilled, (_state) => {})
      .addCase(getEmployeeDetail.rejected, (_state) => {});

    // DELETE: Delete employee
    builder
      .addCase(deleteEmployee.pending, (_state) => {})
      .addCase(deleteEmployee.fulfilled, (_state) => {})
      .addCase(deleteEmployee.rejected, (_state) => {});

    // PUT: Update employee
    builder
      .addCase(updateEmployee.pending, (_state) => {})
      .addCase(updateEmployee.fulfilled, (_state) => {})
      .addCase(updateEmployee.rejected, (_state) => {});

    // PUT: Update status employee
    builder
      .addCase(updateStatusEmployee.pending, (_state) => {})
      .addCase(updateStatusEmployee.fulfilled, (_state) => {})
      .addCase(updateStatusEmployee.rejected, (_state) => {});

    // POST: Upload Excel
    builder
      .addCase(uploadFileExcel.pending, (state) => {})
      .addCase(uploadFileExcel.fulfilled, (state) => {})
      .addCase(uploadFileExcel.rejected, (state) => {});

    // GET: Get Employee Review
    builder
      .addCase(getEmployeeReview.pending, (state) => {})
      .addCase(getEmployeeReview.fulfilled, (state) => {})
      .addCase(getEmployeeReview.rejected, (state) => {});
  },
});

// Action
export const employeeActions = employeeSlice.actions;

// Selectors
export const selectIsRefreshEmployeeList = (state: RootState) => state.employee.isRefreshEmployeeList;

// Reducer
const employeeReducer = employeeSlice.reducer;
export default employeeReducer;
